import React from "react";
import SearchResultsList from "./SearchResultsList";
import Pagination from "./Pagination";
import SearchPageLoadingOverlay from "./SearchPageLoadingOverlay";

function SearchResultsMainContent({
  relatedTerms,
  onRelatedSearch,
  loading,
  results,
  totalResults,
  currentPage,
  lastPage,
  perPage,
  searchCoords,
  selectedResultId,
  onSelectResult,
  onIndicateResult,
  onRestoreResult,
  responseId,
  surveyName,
  savedResourceIds,
  hasSearchTerms,
  onResourceSaved,
  pageNum,
  onPageChange,
  onViewMap,
}) {
  return (
    <>
      <div className="results-content">
        <button className="back-to-results" style={{ display: "none" }}>
          <i className="ico ico-arrowright" /> Back
        </button>
      </div>

      <SearchPageLoadingOverlay loading={loading} />

      <div className="results-region" style={{ display: loading ? "none" : "block" }}>
        <SearchResultsList
          results={results}
          totalResults={totalResults}
          currentPage={currentPage}
          lastPage={lastPage}
          perPage={perPage}
          searchCoords={searchCoords}
          selectedResultId={selectedResultId}
          onSelectResult={onSelectResult}
          onIndicateResult={onIndicateResult}
          onRestoreResult={onRestoreResult}
          responseId={responseId}
          surveyName={surveyName}
          savedResourceIds={savedResourceIds}
          hasSearchTerms={hasSearchTerms}
          onResourceSaved={onResourceSaved}
          pageNum={pageNum}
          onViewMap={onViewMap}
          relatedTerms={relatedTerms}
          onRelatedSearch={onRelatedSearch}
        />
        <div className="pagination-region">
          <Pagination
            currentPage={currentPage}
            lastPage={lastPage}
            onLoadPage={onPageChange}
          />
        </div>
      </div>
    </>
  );
}

export default SearchResultsMainContent;
